module.exports = __webpack_public_path__ + "static/continuous-69e9fdff7199c9058c99d8e074c0a283.jpeg";